import { atom } from 'jotai';

import type { ViolationStepDir } from '@/lib/clearance/navigation';

/**
 * A pending "previous / next violation" request from the viewer hotkeys
 * (`Shift+[` / `Shift+]` in `useViewerHotkeys`) to the open `ClearanceDock`.
 *
 * A request, not a station: only the dock holds the run's bins (they come from
 * the byproduct fetch, not from layer metadata), so only the dock can say
 * where the next violation is. The dock consumes the request and resets it to
 * null, so a dock mounting later never replays a keypress it did not see.
 * `seq` makes two presses in the same direction two distinct writes.
 */
export const clearanceViolationStepAtom = atom<{ dir: ViolationStepDir; seq: number } | null>(null);

/**
 * A pending "walk to this station" for the clearance dock of `layerId` — the
 * overlay card's "Go to worst". The card cannot do it itself: with no walk
 * running yet, the dock's walk-start would seed the run's FIRST station over
 * it, and a walk on another alignment (or a run whose alignment is not loaded,
 * which walks the dock's stand-in cursor instead) is not the card's to move.
 * So the card asks and the dock answers, once it has the run in hand: it
 * seeds a new walk from the target, or moves the existing one, and clears it.
 * INTERNAL station, like the walk's own.
 */
export const clearanceWalkTargetAtom = atom<{ layerId: string; station: number } | null>(null);
